import {config} from "./config";
import {request} from "./request";


function submitOrder(data, cb, fail_cb) {
    request.get.call(this, config.apiList.submitOrder, data, cb, fail_cb)
}

function getRebateSettings(data, cb, fail_cb) {
    request.get.call(this, config.apiList.getRebateSettings, data, cb, fail_cb)
}

function updateRebateSettings(data, cb, fail_cb) {
    request.post.call(this, config.apiList.getRebateSettings, data, cb, fail_cb)
}




var rebateApi = {
    submitOrder: submitOrder,
    getRebateSettings: getRebateSettings,
    updateRebateSettings: updateRebateSettings,
}

export {rebateApi}